import React, { useState , useEffect}  from 'react';
import { useStateContext } from '../../contexts/ContextProvider';
import {usePagosMutations} from '../../hooks';
import { SearchClienteEstado } from '../../components';
import { fetchUser } from '../../utils/fetchUser';
import { Toaster,toast } from 'react-hot-toast';
import {getRegistroPagosRut} from "../../services/RegistroPagos";
import {getClientesRut} from "../../services/Clientes";
import {getPlanes} from "../../services/Planes";
import {getRegistroPlanesRut} from "../../services/RegistroPlanes";

import ButtonToolBar from '../../components/ButtonToolBar';
import {formatDate} from '../../formatters/date';


const initialState = {
_id: null,
empresa: null,
numeroPago: '',
idRegistroPlan: null,
idPlan: null,
valor: '',
idCliente: '',
rutCliPro: '',
razonSocial:'',
monto: '',
medioPago: 'Efectivo',
numeroComprobante: '',
descripcion:'',
estado: 'Pendiente',
fechaCreacion: Date.now()
};

const RegistroPagos = () => {
  const { currentColor, isClicked, setIsClicked } = useStateContext();
  const [formData, setFormData] = useState(initialState);
  const [planesData, setPlanesData] = useState([]);
  const { addPago, updatePagoC, removePago } = usePagosMutations();

  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";

  const [buttonsTool, setButtonsTool] = useState([
    { name: 'cancel', label: 'Cancelar', disabled: false },
    { name: 'delete', label: 'Eliminar', disabled: false },
    { name: 'save', label: 'Guardar', disabled: false },
    { name: 'enviar', label: 'Leer', disabled: false },
  ]);

  const userInfo = fetchUser();

  useEffect(() => {
    const fetchData = async () => {
      let miPlan = null;
      let miRegistro = null;
      let miValor = null;
      const miCliente = await getClientesRut(formData.rutCliPro);
      if (miCliente.length > 0) {
        const miRegistroPlanes = await getRegistroPlanesRut(formData.rutCliPro);
        if (miRegistroPlanes.length > 0) {
          miPlan = miRegistroPlanes[0].idPlan;
          miRegistro = miRegistroPlanes[0]._id;
          miValor = miRegistroPlanes[0].valor;
        }
        setFormData((prev) => ({
        ...prev,
        razonSocial: miCliente[0].razonSocial, idCliente: miCliente[0]._id, idPlan: miPlan, idRegistroPlan: miRegistro, valor: miValor
      }));
    }
    };
    if(formData.rutCliPro !== '') {
      // Lee datos cliente usando API por rut
      fetchData();
    }
  }, [formData.rutCliPro]);

  useEffect(()=>{
    const fetchData = async () => {
      const misPlanes = await getPlanes();
      setPlanesData(misPlanes);
    };
    fetchData();
  },[]);

  useEffect(() => {
    if (formData.idPlan !== "" && formData.idPlan !== undefined) {
      const cSel = planesData.find((item) => item._id === formData.idPlan);
      if (cSel) {
        setFormData((prev) => ({
          ...prev,
          valor: cSel.valor,
        }));
      }
    }else {
      setFormData((prev) => ({  ...prev, valor: '' }));
    }
  }, [formData.idPlan, planesData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  
  const handleDelete = async () =>{
    try {

      console.log("Eliminando Pago: " + formData._id);

        if (formData._id !== null) {
        /*  const datosSolicitud = {
            empresa: userInfo.empresa,
            _id: formData._id,
            numeroPago: formData.numeroPago,
            idRegistroPlan: formData.idRegistroPlan,
            monto: formData.monto,
            medioPago: formData.medioPago,
            numeroComprobante: formData.numeroComprobante,
            descripcion: formData.descripcion,
            estado: 'Anulado',
            fechaCreacion: formData.fechaCreacion,
          };*/
          await removePago.mutateAsync( formData._id );
          toast.success("Pago eliminado correctamente "); 
          setFormData(initialState);

        } else {
          toast.error("Seleccione un Pago para eliminar");
          return;
        }
    } catch (error) {
      console.log("Problemas al momento de Eliminar Pago, contacte a soporte" + error);
      toast.error("Problemas al momento de Eliminar Pago, contacte a soporte");
    }
  };

  const handleLeer = async () =>{
    try {
  
      if (formData.rutCliPro !== '' && formData.numeroPago !== '') {
        const miCliente = await getRegistroPagosRut(formData.rutCliPro, formData.numeroPago);
        if (miCliente.length === 0) {
          toast.error("No se encontraron resultados para la búsqueda");
          return;
        }
        setFormData((prev) => ({
          ...prev,
          _id: miCliente[0]._id,
          numeroPago: miCliente[0].numeroPago,
          idRegistroPlan: miCliente[0].idRegistroPlan,
          idPlan: miCliente[0].idPlan,
          valor: miCliente[0].valor,
          idCliente: miCliente[0].idCliente,
          rutCliPro: miCliente[0].rutCliPro,
          razonSocial: miCliente[0].razonSocial,
          monto: miCliente[0].monto,
          medioPago: miCliente[0].medioPago,
          numeroComprobante: miCliente[0].numeroComprobante,
          descripcion: miCliente[0].descripcion,
          estado: miCliente[0].estado,
        }));
      } else {
        toast.error("Ingrese Rut y N° Pago para buscar");
      }

      
    } catch (error) {
      console.log("Problemas al momento de Eliminar Pago, contacte a soporte" + error);
      toast.error("Problemas al momento de Eliminar Pago, contacte a soporte");
    }
  };

  const handleSubmit = async () =>{
    
    try {
        if (formData._id === null) {
          const datosSolicitud = {
            empresa: userInfo.empresa,
            numeroPago: 0,
            idCliente: formData.idCliente,
            idRegistroPlan: formData.idRegistroPlan,
            monto: formData.monto,
            medioPago: formData.medioPago,
            numeroComprobante: formData.numeroComprobante,
            descripcion: formData.descripcion,
            estado: 'Pagado',
            fechaCreacion: Date.now(),
          };
         const daRecp = await addPago.mutateAsync( datosSolicitud );
         toast.success("Pago registrado con N° " + daRecp.numeroPago );
        } else {
          const datosSolicitud = { 
            empresa: userInfo.empresa,
            numeroPago: formData.numeroPago,
            idCliente: formData.idCliente,
            idRegistroPlan: formData.idRegistroPlan,
            monto: formData.monto,
            medioPago: formData.medioPago,
            numeroComprobante: formData.numeroComprobante,
            descripcion: formData.descripcion,
            estado: 'Pagado',
            fechaCreacion: formData.fechaCreacion,
           };
          await updatePagoC.mutateAsync( datosSolicitud );  
          toast.success("Pago modificado correctamente "); 
        }
         setFormData(initialState);

    } catch (error) {
      console.log("Problemas al momento de Registrar Cliente y Plan, contacte a soporte" + error);
      toast.error("Problemas al momento de Registrar Cliente y Plan, contacte a soporte");
    }
  }
 
  const handleCancelar = async () =>{  
      setFormData(initialState);
  }

  const handleButtonToolBarClick = (buttonName) => {
    if (buttonName === 'save') {
      handleSubmit();
    } else if (buttonName === 'delete') {
      handleDelete();
    } else if (buttonName === 'enviar') {
      handleLeer();
    } else if (buttonName === 'cancel') {
      handleCancelar();
    }
  };

  return (
    <form  onSubmit={handleSubmit} >
        <div className="m-2 md:m-10 mt-16 p-2 md:p-4 bg-gray-100 rounded-3xl">

        <div className="container mx-auto p-2 md:p-2">

        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-green-800 animate-pulse" />
                <p className="text-gray-800 font-semibold text-base md:text-lg">
                  Registro Pagos
                </p>
              </div>

            </div>

     <div className="bg-gray-200 p-6 rounded-lg shadow-lg mt-2">
        <div className="grid grid-cols-3 md:grid-cols-7 gap-4" >
            <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">N° Pago</label>            
                <input
                className={inputClass}
                type="text"
                placeholder=""
                name="numeroPago"
                value= {formData.numeroPago}
                onChange={handleChange}
              />
            </div>
            <div className="flex flex-col items-start">      
              <label className="text-xs font-semibold mb-1">Fecha</label>            
              <input
                className={inputClass}
                type="text"
                placeholder=""
                name="fechaCreacion"
                value= {formatDate(formData.fechaCreacion)}
                disabled
              />
            </div>
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">Rut</label>
              <input
              className={inputClass}
              type="text"
              placeholder=""
              name="rutCliPro"
              value= {formData.rutCliPro}
              onChange={handleChange}
              />
            </div> 
            <div className="flex flex-col">
              <SearchClienteEstado estado='Activo' 
              onValorSeleccionadoChange={(cliSeleccionado) => {
                if (!cliSeleccionado) return;

                setFormData((prev) => ({
                  ...prev,
                    rutCliPro: cliSeleccionado.rutCliPro,
                    razonSocial: cliSeleccionado.razonSocial,
                }));

              }}
               />
            </div>



                <div className="col-span-2">
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Nombre</label>
                    <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="razonSocial"
                      value= {formData.razonSocial}
                      onChange={handleChange}
                      disabled 
                    />
                  </div> 
                </div>
              <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">Plan</label>
                <select className={inputClass} name="idPlan" 
                value= {formData.idPlan} 
                disabled
                onChange={handleChange}>
                  <option value=""></option>
                  {planesData?.map((item, index) => (
                    <option  key={item._id} value={item._id}>{item.nombrePlan}</option>
                  ))}  
                  </select> 
              </div> 

              <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Precio</label>
                  <input
                    className={inputClass}
                    type="text"
                    placeholder=""
                    name="valor"
                    value= {formData.valor}
                    onChange={handleChange}
                    disabled 
                  />
                </div> 
            </div>    
        </div>   

          <div className="mt-5 space-y-4">
              <div className="bg-white p-6 rounded-lg shadow-lg items-end">
                <div className="grid grid-cols-1 md:grid-cols-6 gap-4" >

                  <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Medio de Pago</label>
                      <select className={inputClass} name="medioPago" value= {formData.medioPago} required onChange={handleChange}>   
                        <option value="Efectivo">Efectivo</option>
                        <option value="Transferencia">Transferencia</option>  
                        <option value="Crédito">Crédito</option> 
                        <option value="Débito">Débito</option>      
                      </select>
                  </div>  

                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Monto</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="monto"
                        value= {formData.monto}
                        onChange={handleChange}
                      />
                  </div>  
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">N° Comprobante</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="numeroComprobante"
                        value= {formData.numeroComprobante}
                        onChange={handleChange}
                      />
                  </div>  
                  <div className="col-span-3">
                      <div className="flex flex-col">
                          <label className="text-xs font-semibold mb-1">Observación</label>
                          <input
                              className={inputClass}
                              type="text"
                              placeholder=""
                              name="descripcion"
                              value= {formData.descripcion}
                              onChange={handleChange}
                            />
                      </div>  
                    </div> 
                </div>

                <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
                  <div className="flex flex-col mt-4">
                    <ButtonToolBar buttons={buttonsTool} onButtonClick={handleButtonToolBarClick} />
                  </div>
                </div>

              </div>   
              <Toaster  position="top-right"  toastOptions={{  style: {  zIndex: 9999,  },  }} />         
          </div>

        </div>
      </div>
    </form>
  );
};

export default RegistroPagos;